import { UntypedFormBuilder } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { PagingSearchCriteria } from "src/app/shared/model/PagingSearchCriteria";

export interface GetReceivedPortalMessagesByUserCriteria extends PagingSearchCriteria {
    portalUserId: string | null;
    readFromDate: Date;
    readToDate: Date;
    onlyPriority: boolean;
}


export class GetReceivedPortalMessagesByUserCriteriaFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, searchCriteria: GetReceivedPortalMessagesByUserCriteria)  {
  
      return fb.group(
        {
            portalUserId: [searchCriteria.portalUserId],
            readFromDate: [this.dateValue(searchCriteria.readFromDate)],
            readToDate: [this.dateValue(searchCriteria.readToDate)],
            onlyPriority: [!!searchCriteria.onlyPriority]
        }
      );
    }

    static initGetReceivedPortalMessagesByUserCriteria(): GetReceivedPortalMessagesByUserCriteria {
        
        const readToDate = new Date();
        readToDate.setDate(readToDate.getDate() - 14);

      return {
        portalUserId:null,
        readFromDate: readToDate,
        readToDate: new Date(),
        onlyPriority: false,
        pageNumber: 1,
        rowsPerPage: 25,
        sortDirection: 'DESC',
        sortColumn: '',
        
      };
    }
  }